import styles from './WarningModal.module.scss';
import ValidateButton from '../UI/ValidateButton';
import Close from '@src/assets/Close.png';

type WarningModalProps = {
    image: any;
    show: boolean;
    onValidate: (value: boolean) => void;
    title?: string;
    content: string;
}

export default function WarningModal({image, show, onValidate, title = 'Vous ne pouvez pas devenir client', content}: WarningModalProps) {
    if (!show) {
        return null;
    }

    return (
        <div className={styles.modalContainer}>
            <div className={styles.modal}>
                <div className={styles.close} onClick={() => onValidate(true)}>
                    <img src={Close} alt="Close" width={14} height={14} />
                </div>
                <div className={styles.imageContainer}>
                    <img src={image} alt="Close" width={217} height={183} />
                </div>
                <p className={styles.title}>{title}</p>
                <p className={styles.description}>{content}</p>
                <ValidateButton isModal title="Retour" onClick={() => onValidate(true)}/>
            </div>
        </div>
    );
}
